export default __webpack_public_path__ + "static/media/password_reset.dcc55f2c.svg";